<template>

      <div class="box"
           :class="{ 'is-danger': isOverlength }">
        <article class="media">          
          <div class="media-left vertical-center">
            <figure class="image is-16by9 slide-image"> 
              <a @click="isImageModalActive = true">
                <img :src="slide.slideImage" 
                    class="slide-thumb"                   
                    v-if="slide.slideImage">
              </a>
            </figure>    
          </div>

          <b-modal :active.sync="isImageModalActive" :width="960" class="slide-image-modal">
              <p class="image is-16by9">
                  <img :src="slide.slideImage">
              </p>
          </b-modal>

          <div class="vertical-rule"></div>

          <div class="media-content"
               v-if="mode === 'display'">            
            <div class="content display-mode">
              <div>
                <nl2br tag="p" :text="computedSlideText"></nl2br>  
              </div>             

            </div>

            <div class="field is-grouped is-grouped-right">
              <!-- <div class="control">
                <small class="help counter">{{ characterCount }} / 280</small>
              </div>               -->
              <p class="control">
                <a class="button is-primary"
                   @click="switchToEditMode()">
                    <span class="icon is-small">
                    <i class="fa fa-pencil-square-o"></i>
                  </span>
                  <span>Edit</span>                        
                </a>
              </p>
            </div>
          </div>

          <div class="media-content"
               v-if="mode === 'edit'">
            <div class="content">
              <div class="field">
                <div class="control">
                  <input class="input" type="text" placeholder="Tweet prefix" :value="computedPrefixText" disabled>                   
                </div>
              </div>

              <div class="field">
                <div class="control">
                  <textarea class="textarea"
                            :class="{ 'is-danger': isOverlength }" 
                            placeholder="Tweet text for this slide"
                            v-model="slide.editText">
                  </textarea>
                  <small class="help counter"
                         :class="{ 'is-danger': isOverlength }">{{ characterCount }} / 280</small>
                </div>                      
              </div>

              <div class="field">
                <div class="control">
                  <input class="input" type="text" placeholder="Tweet suffix" :value="computedSuffixText" disabled>
                </div>
              </div>                    

              <div class="field is-grouped is-grouped-right">
                <p class="control">
                  <a class="button is-primary"
                     @click="switchToDisplayMode(true)">
                      <span class="icon is-small">
                      <i class="fa fa-check"></i>
                    </span>
                    <span>Ok</span>                        
                  </a>
                </p>
                <p class="control">
                  <a class="button is-light"
                     @click="switchToDisplayMode(false)">
                      <span class="icon is-small">
                      <i class="fa fa-ban"></i>
                    </span>
                    <span>Cancel</span>    
                  </a>
                </p>
              </div>
              
            </div>
          </div>

        </article>
      </div>

</template>

<script>
import EditSectionSlideBase from './EditSectionSlideBase.vue';

export default {
  name: "EditSectionSlide",
  extends: EditSectionSlideBase,
  props: {
  },
  components: {
  },
  data: function() {
    return {

    };
  },
  computed: {
  },
  methods: {
  }
};
</script>

<style lang="scss" scoped>
.box.is-danger {
  border: 2px solid #ff3860;
}

.image.is-256x144 {
  width: 256px;
  height: 144px;
}

.slide-image {
  width: 256px;
}

.slide-thumb {
  border: 1px solid lightgray;
  // box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
}

.vertical-rule {
  width: 1px;
  align-self: stretch;
  background: lightgray;
  margin-right: 1rem;
}

.vertical-center {
  align-self: center;
}

.content.display-mode {
  min-height: 96px;
}

div.control small.help.counter {
  margin-bottom: 0.75rem;
}
</style>



// WEBPACK FOOTER //
// src/components/create/EditSectionSlide.vue